import React from "react";
import "../ProjectSection/ProjectSection.css";

export default function ProjectCard({ project }) {
  return (
    <div className="project_item layout-col-lg-4 layout-col-md-6 layout-col-sm-12">
      <h2>
        <span>Client:</span> {project.client}
      </h2>
      <h2>
        <span>Country:</span> {project.Country}
      </h2>
      {project.year === null ? (
        ""
      ) : (
        <>
          <h2>
            <span>Year of Completion:</span> {project.year}
          </h2>
        </>
      )}
      {/* <h2>
        <span>Value:</span> {project.value}
      </h2> */}
      {project.project_categories[0].title === "on_going" && (
        <h2>
          <span>Category:</span> On Going
        </h2>
      )}
      {project.project_categories[0].title === "completed" && (
        <h2>
          <span>Category:</span> Completed
        </h2>
      )}
      {project.project_categories[0].title === "supply" && (
        <h2>
          <span>Category:</span> Supply
        </h2>
      )}
      <h2>
        <span>Description</span>
      </h2>
      <p>{project.description}</p>
      {project.scope === null ? (
        ""
      ) : (
        <>
          <h2>
            <span>Scope</span>
          </h2>
          <p>{project.scope}</p>
        </>
      )}
    </div>
  );
}
